const routes = [
  {
    path: '/checkout/:enquiryReference',
    name: 'checkout',
    component: () => import('@/portal/components/checkout/index.vue'),
    meta: {
      title: "Checkout",
      guest: true,
    },
  },
  {
    path: '/announcements',
    name: 'announcements',
    component: () => import('@/portal/components/announcement/index.vue'),
    meta: {
      title: "Announcements"
    },
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: () => import('@/portal/components/notification/index.vue'),
    meta: {
      title: "Notifications"
    },
  },
]

export default routes
